/**
 * Constants for ARPS calculations
 */

/**
 * Conversion factor from cubic feet to thousands of cubic feet (MCF)
 */
export const CUBIC_FEET_TO_MCF = 0.001;

/**
 * Milliseconds in one day (24 hours * 60 minutes * 60 seconds * 1000 milliseconds)
 */
export const MILLISECONDS_PER_DAY = 1000 * 60 * 60 * 24;

/**
 * Default flat segment duration in months for SAGD templates
 */
export const DEFAULT_TFLAT = 12;

/**
 * Convert milliseconds to days
 */
export function millisecondsToDays(milliseconds: number): number {
  return milliseconds / MILLISECONDS_PER_DAY;
}

/**
 * Convert Date to Unix timestamp in seconds
 */
export function dateToUnixSeconds(date: Date): number {
  return Math.round(date.getTime() / 1000);
}

/**
 * Convert Date to Unix timestamp in seconds as BigInt for WASM calls
 */
export function dateToUnixSecondsBigInt(date: Date): bigint {
  return BigInt(dateToUnixSeconds(date));
}
